import React from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {ModernTooltip} from '../../../../../../components/Common/Tooltip/ModernTooltip';

type IconWithTooltipProps = {
    componentClasses?: string;
    icon: PriorityIcon;
    tooltip?: string;
    onClick?: () => void;
    disabled?: boolean;
    dataTestId?: string;
};

export const IconWithTooltip = (props: IconWithTooltipProps) => {
    const {disabled, tooltip} = props;

    const iconElement = <Icon {...props} />;

    if (disabled || !tooltip) {
        return iconElement;
    }

    return (
        <ModernTooltip tooltip={tooltip} position="top-start">
            {iconElement}
        </ModernTooltip>
    );
};
